import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Mailboxes/Management/AddMailbox'

export const FETCH_ALL_TAGS_ASYNC = createAsyncTypes('FETCH_ALL_TAGS_ASYNC', typeKey)
export const FETCH_TITLES_ASYNC = createAsyncTypes('FETCH_TITLES_ASYNC', typeKey)
export const FETCH_DEPARTMENTS_ASYNC = createAsyncTypes('FETCH_DEPARTMENTS_ASYNC', typeKey)

export const SET_ALL_TAGS_SEARCH = `${typeKey}/SET_ALL_TAGS_SEARCH`
export const SET_ALL_TAGS_PAGE = `${typeKey}/SET_ALL_TAGS_PAGE`
export const SET_TITLES_SEARCH = `${typeKey}/SET_TITLES_SEARCH`
export const SET_TITLES_PAGE = `${typeKey}/SET_TITLES_PAGE`
export const SET_DEPARTMENTS_SEARCH = `${typeKey}/SET_DEPARTMENTS_SEARCH`
export const SET_DEPARTMENTS_PAGE = `${typeKey}/SET_DEPARTMENTS_PAGE`

export const SET_SELECTED_TITLE = `${typeKey}/SET_SELECTED_TITLE`
export const SET_SELECTED_DEPARTMENT = `${typeKey}/SET_SELECTED_DEPARTMENT`
export const SET_SELECTED_ALL_TAGS = `${typeKey}/SET_SELECTED_ALL_TAGS`

export const CLEAR_ALL_VALUES = `${typeKey}/CLEAR_ALL_VALUES`
